module.exports = __webpack_public_path__ + "img/sport-2-640.2ca90796.jpg";